export enum AdvertisementProviderStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
